export default __webpack_public_path__ + "static/media/restaurant.445ff0dc.png";